import { compact } from 'lodash';

export function textFilter(filterValue: string, dataValues: string[]) {
  if (!filterValue) return true;
  const filterValueParts = compact(filterValue.split(' '));
  return dataValues.some((dataValue) => {
    return filterValueParts.every((part) =>
      dataValue.toLowerCase().includes(part.toLowerCase())
    );
  });
}
